export const containersColumns = (t: any) => [
    {
        key: "containerNumber",
        name: t('containers.columns.containerNumber'),
        fieldName: 'containerNumber',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "closestReceptionPlaceAddress",
        name: t('containers.columns.approximateLocation'),
        fieldName: 'closestReceptionPlaceAddress',
        minWidth: 100,
        maxWidth: 250,
        isResizable: true,
    },
    {
        key: "serNo",
        name: t('containers.columns.serialNumber'),
        fieldName: 'serNo',
        minWidth: 75,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "lastActiveDate",
        name: t('containers.columns.lastActivity'),
        fieldName: 'lastActiveDateStr',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "internalStoreName",
        name: t('containers.columns.warehouse'),
        fieldName: 'internalStoreName',
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "status",
        name: t('containers.columns.status'),
        fieldName: 'status',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
        onRender: (item: any) => t(`containers.status.${item.status}`, { defaultValue: t('containers.status.default') }),
    },
    {
        key: "currentBatteryStatusString",
        name: t('containers.columns.batteryMaintenance'),
        fieldName: 'currentBatteryStatus',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
        onRender: (item: any) => t(`containers.batteryStatus.${item.currentBatteryStatus}`),
    },
    {
        key: "assignedInternalStoreName",
        name: t('containers.columns.serviceWarehouse'),
        fieldName: 'assignedInternalStoreName',
        minWidth: 100,
        maxWidth: 250,
        isResizable: true,
    },
]